/* eslint-disable func-names */
import React from 'react';
import { connect } from 'react-redux';
import { Tooltip, Zoom, Fab } from '@material-ui/core';
import { Add, Save, Queue } from '@material-ui/icons';
import { SpeedDial, SpeedDialIcon } from '@material-ui/lab';
import PropTypes from 'prop-types';
import 'ag-grid-enterprise';
import { AgGridReact } from 'ag-grid-react';
import ListingsTooltip from '../../../components/ListingsTooltip';
import SpeedDialAction from '../../../components/SpeedDialActionComponent'; // import { isDef } from '../../utils/validations';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import '../../../styles/Tooltip.scss';
import ValidateUser from '../../../components/UserStatus';

const isDef = val => val !== null || val !== undefined;

const actions = [{ icon: <Queue />, name: 'Add listings to existing group', func: 'addListingsButtonClickedMask' }];

let inventoryColumnDefinitions = [
  {
    headerName: 'Section',
    field: 'section',
    filter: 'agTextColumnFilter',
    pinned: true,
    headerCheckboxSelection: true,
    headerCheckboxSelectionFilteredOnly: true,
    checkboxSelection: true,
    sortable: true,
    sort: 'asc',
    resizable: true,
    cellRenderer: 'agGroupCellRenderer',
    minWidth: 110,
  },
  {
    headerName: 'Row(s)',
    field: 'rows',
    filter: true,
    resizable: true,
    cellRendererFramework: ListingsTooltip,
    sortable: true,
  },
  {
    headerName: 'Seats',
    field: 'seats',
    filter: true,
    resizable: true,
    cellRendererFramework: ListingsTooltip,
    sortable: true,
  },
  {
    headerName: 'Quantity',
    field: 'quantity',
    filter: 'agNumberColumnFilter',
    cellRendererFramework: ListingsTooltip,
    resizable: true,
    sortable: true,
  },
  {
    headerName: 'Unit Cost',
    field: 'unit_cost',
    filter: 'agSetColumnFilter',
    cellRendererFramework: ListingsTooltip,
    resizable: true,
    sortable: true,
  },
  {
    headerName: 'Properties',
    field: 'deliveryMethod',
    filter: 'agSetColumnFilter',
    resizable: true,
    cellRendererFramework: ListingsTooltip,
  },
  {
    headerName: 'Tags',
    field: 'tags',
    filter: 'agTextColumnFilter',
    resizable: true,
    cellRendererFramework: ListingsTooltip,
    sortable: true,
  },
  {
    headerName: 'Org Name',
    field: 'org_name',
    filter: 'agTextColumnFilter',
    resizable: true,
    cellRendererFramework: ListingsTooltip,
    sortable: true,
  },
  {
    headerName: 'ID',
    field: 'skybox_listing_id',
    hide: true,
    cellRendererFramework: ListingsTooltip,
  },
  {
    headerName: 'List Price',
    field: 'list_price',
    hide: true,
    cellRendererFramework: ListingsTooltip,
  },
];

const detailCellRendererParams = {
  detailGridOptions: {
    columnDefs: [{ field: 'seats' }, { field: 'public_notes' }, { field: 'internal_notes' }, { field: 'tags' }],
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
  },
  getDetailRowData(params) {
    params.successCallback(params.data.listing_detail);
  },
};
class UngroupedListings extends React.Component {
  constructor(props) {
    super(props);

    const firstGroupTagsToCheck = ['nontransferable_rotating'];

    this.state = {
      openDial: false,
      showTooltip: false,
      getRowStyle: params => {
        if (params.data.hold) {
          return { background: '#B71C1C', border: '1px solid #696969' };
        }
        if (isDef(params.data) && params.data.qcStatus) {
          return { background: '#F9A825', border: '1px solid #696969' };
        }
        if (params && params.data && params.data.tags) {
          if (firstGroupTagsToCheck.some(t => params.data.tags.includes(t))) {
            return { background: '#ff66cc', border: '1px solid #696969' };
          }
        }
        return false;
      },
    };

    if (props.isAbTest) {
      inventoryColumnDefinitions = inventoryColumnDefinitions.filter(function(column) {
        return column.field !== 'unit_cost';
      });
    }
  }

  /*
   * Open the speed dial
   */
  handleOpen = () => {
    this.setState({ openDial: true, showTooltip: true });
  };

  /*
   * Close the speed dial
   * @param {number} eventID id of the event to fetch the static graph
   */
  handleClose = () => {
    this.setState({ openDial: false, showTooltip: false });
  };

  /*
   * Trigger the addListingsButtonClicked
   */
  addListingsButtonClickedMask = e => {
    e.stopPropagation();
    const { addListingsButtonClicked } = this.props;
    addListingsButtonClicked();
  };

  /*
   * Trigger the onGridReady from Ag Grid when the Grid is mounted and ready
   */
  onGridReady = params => {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
    window.addEventListener('resize', () => {
      setTimeout(() => {
        this.gridApi.sizeColumnsToFit();
      });
    });
    try {
      // eslint-disable-next-line no-param-reassign
      // params.api.context.beanWrappers.tooltipManager.beanInstance.MOUSEOVER_SHOW_TOOLTIP_TIMEOUT = 0;
    } catch (e) {
      throw e;
    }
  };

  /*
   * Trigger the onSelectionChanged when you select a row on Ag Grid
   */
  onSelectionChangedAgGrid = () => {
    const { onSelectionChanged } = this.props;
    const selectedRows = this.gridApi.getSelectedNodes();
    onSelectionChanged(selectedRows);
  };

  render() {
    const {
      classes,
      createGroupButtonDisabled,
      focusedPricingGroup,
      transitionDuration,
      inventoryRows,
      theme,
      createGroupButtonClicked,
    } = this.props;
    const { openDial, showTooltip, getRowStyle } = this.state;
    return (
      <div
        className={theme.palette.type === 'dark' ? 'ag-theme-balham-dark' : 'ag-theme-balham'}
        style={{
          // position: 'relative',
          boxSizing: 'border-box',
          width: '100%',
          height: '100%',
        }}
      >
        <ValidateUser />
        {focusedPricingGroup ? (
          <Tooltip placement="left" title="Create new group with listings" open={showTooltip}>
            <SpeedDial
              className={classes.addButton}
              ariaLabel="SpeedDial example"
              hidden={createGroupButtonDisabled}
              icon={<SpeedDialIcon openIcon={<Save />} />}
              onBlur={this.handleClose}
              onClick={createGroupButtonClicked}
              onClose={this.handleClose}
              onMouseEnter={this.handleOpen}
              onMouseLeave={this.handleClose}
              open={openDial}
              direction="up"
            >
              {actions.map(action => (
                <SpeedDialAction
                  key={action.name}
                  icon={action.icon}
                  tooltipTitle={action.name}
                  onClick={this[action.func]}
                  tooltipOpen={!createGroupButtonDisabled}
                />
              ))}
            </SpeedDial>
          </Tooltip>
        ) : (
          <Zoom
            in={!createGroupButtonDisabled}
            timeout={transitionDuration}
            style={{
              transitionDelay: `${!createGroupButtonDisabled ? 50 : 0}ms`,
            }}
            unmountOnExit
          >
            <Fab
              onClick={createGroupButtonClicked}
              color="primary"
              aria-label="Add"
              className={classes.addButton}
              data-testid="create-group-button"
            >
              <Add />
            </Fab>
          </Zoom>
        )}
        {}
        <div style={{ height: '100%', width: '100%', position: 'relative' }}>
          <AgGridReact
            tooltupShowDelay={0}
            onGridReady={this.onGridReady}
            onSelectionChanged={this.onSelectionChangedAgGrid}
            columnDefs={inventoryColumnDefinitions}
            detailCellRendererParams={detailCellRendererParams}
            getRowStyle={getRowStyle}
            rowDataChangeDetectionStrategy="IdentityCheck"
            rowData={inventoryRows}
            floatingFilter
            rowSelection="multiple"
            animateRows
            // frameworkComponents={frameworkComponents}
            statusBar={{
              // TODO: refactor this to redux default state
              statusPanels: [
                {
                  statusPanel: 'agTotalRowCountComponent',
                  align: 'left',
                },
                { statusPanel: 'agFilteredRowCountComponent' },
                { statusPanel: 'agSelectedRowCountComponent' },
                { statusPanel: 'agAggregationComponent' },
              ],
            }}
            masterDetail
            debug={false}
          />
        </div>
      </div>
    );
  }
}

UngroupedListings.propTypes = {
  theme: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  transitionDuration: PropTypes.object.isRequired,
  createGroupButtonDisabled: PropTypes.bool.isRequired,
  inventoryRows: PropTypes.array.isRequired,
  createGroupButtonClicked: PropTypes.func.isRequired,
  onSelectionChanged: PropTypes.func.isRequired,
  addListingsButtonClicked: PropTypes.func.isRequired,
  focusedPricingGroup: PropTypes.number,
  isAbTest: PropTypes.bool.isRequired,
};

UngroupedListings.defaultProps = {
  focusedPricingGroup: null,
};

function mapStateToProps(state) {
  return {
    focusedPricingGroup: state.pricing.ui.focusedPricingGroup,
  };
}

export default connect(mapStateToProps)(UngroupedListings);
